import React from 'react';
import { useTranslation } from 'react-i18next';

const ButtonModalClose = ({ buttonRef, closeModal }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      ref={buttonRef || null}
      className="bg-blue-100 border border-blue-500 rounded-md shadow-sm cursor-pointer p-2 absolute top-4 right-4 transition-colors z-50"
      aria-label="Close Modal"
      aria-labelledby="close-modal"
      onClick={closeModal}
    >
      <span className="sr-only" id="close-modal">
        {t('common.close')}
      </span>
      <svg
        className="stroke-current text-blue-500 w-6 h-6"
        viewBox="0 0 40 40"
      >
        <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
      </svg>
    </button>
  );
};

export default ButtonModalClose;
